import React from 'react';
import { Provider } from 'react-redux';
import Store from 'states/redux/Store';
import Configs from 'utils/Configs';

export const AppContext = React.createContext();

export default class AppProvider extends React.Component {
  static instance;

  constructor() {
    super();
    this.state = {
      itemMenuSelected: 0,
      userData: Configs.user,
      language: Configs.language,
      listCartItem: []
    };
    AppProvider.instance = this;
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        <Provider store={Store}>{this.props.children}</Provider>
      </AppContext.Provider>
    );
  }
}
